"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceBannerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var moment = require("moment");
var MaintenanceBannerWidget = /** @class */ (function (_super) {
    __extends(MaintenanceBannerWidget, _super);
    function MaintenanceBannerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showBanner: false
        };
        return _this;
    }
    MaintenanceBannerWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.falconConvenienceApiService.getSettings()
            .subscribe(function (settings) {
            var _a, _b, _c, _d;
            var savedStartDate = ((_a = settings === null || settings === void 0 ? void 0 : settings.maintenanceBanner) === null || _a === void 0 ? void 0 : _a.startDate) ? new Date(settings.maintenanceBanner.startDate) : new Date();
            var savedEndDate = ((_b = settings === null || settings === void 0 ? void 0 : settings.maintenanceBanner) === null || _b === void 0 ? void 0 : _b.endDate) ? new Date(settings.maintenanceBanner.endDate) : new Date();
            var enableForMotors = ((_c = settings === null || settings === void 0 ? void 0 : settings.maintenanceBanner) === null || _c === void 0 ? void 0 : _c.enableForMotors) === true;
            var enableForRenters = ((_d = settings === null || settings === void 0 ? void 0 : settings.maintenanceBanner) === null || _d === void 0 ? void 0 : _d.enableForRenters) === true;
            if (((_this.props.product === services_1.ProductsEnum.SUBSCRIPTION && (enableForMotors || enableForRenters)) ||
                ((_this.props.product === services_1.ProductsEnum.MOTOR && enableForMotors) ||
                    (_this.props.product === services_1.ProductsEnum.RENTERS && enableForRenters))) &&
                new Date().getTime() < savedEndDate.getTime()) {
                var bannerDay = void 0;
                var bannerTime = void 0;
                if (savedEndDate.getDay() === savedStartDate.getDay()) {
                    bannerDay = moment(savedEndDate).format("dddd D MMMM");
                }
                else {
                    bannerDay = moment(savedStartDate).format("dddd D MMMM") + " to " + moment(savedEndDate).format("dddd D MMMM");
                }
                bannerTime = moment(savedStartDate).format("HH:mm") + " - " + moment(savedEndDate).format("HH:mm");
                _this.setState({
                    bannerDay: bannerDay,
                    bannerTime: bannerTime,
                    showBanner: true
                });
            }
        }, function (error) {
            console.error("Something went wrong", error);
        });
    };
    MaintenanceBannerWidget.prototype.render = function () {
        return (this.state.showBanner &&
            (0, jsx_runtime_1.jsxs)("div", { className: "banner journey-content mb-3", children: [(0, jsx_runtime_1.jsx)("img", { src: "/img/alert-orange.svg", alt: "Orange alert icon" }), (0, jsx_runtime_1.jsx)("div", { className: "banner-text", children: (0, jsx_runtime_1.jsxs)("p", { children: ["On ", (0, jsx_runtime_1.jsx)("b", { children: this.state.bannerDay }), " between ", (0, jsx_runtime_1.jsx)("b", { children: this.state.bannerTime }), " you may find that you\u2019re unable to get a new ", services_1.resourcesHelper.THEME, " quote. If your quote is unsuccessful please try again after this time. Thanks for your patience."] }) })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], MaintenanceBannerWidget.prototype, "falconConvenienceApiService", void 0);
    return MaintenanceBannerWidget;
}(React.Component));
exports.MaintenanceBannerWidget = MaintenanceBannerWidget;
//# sourceMappingURL=MaintenanceBannerWidget.js.map